import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { BoxxOAuthResponseProps } from '../contracts/IBoxxOAuth';

@Injectable()
export abstract class BoxxOAuthTemplateMethod {
  isHybridPlatform = false;

  constructor(platform: Platform) {
    platform.ready().then(() => {
      this.isHybridPlatform = platform
        .platforms()
        .some(platform => ['cordova', 'capacitor'].includes(platform));
    });
  }

  oauth(config?: any) {
    return this.isHybridPlatform ? this.nativeOAuth(config) : this.webOAuth(config);
  }

  manageOAuthError(error: any = 'Unknown Error') {
    /*
        // FOR APPLE SIGN IN: https://github.com/twogate/cordova-plugin-sign-in-with-apple#error-type
        1000 ASAuthorizationErrorUnknown
        authorization attempt failed for an unknown reason
        1001 ASAuthorizationErrorCanceled
        user cancelled
        1002 ASAuthorizationErrorInvalidResponse
        authorization request received an invalid response.
        1003 ASAuthorizationErrorNotHandled
        user cancelled
      */
    if (
      [
        'The user canceled the sign-in flow.' /*<-- GOOGLE NATIVE (ios):*/,
        'auth/popup-closed-by-user' /* GOOGLE JS */,
        12501 /*<-- GOOGLE NATIVE (android):*/,
      ].includes(error) ||
      error.errorCode === '4201' /*<-- FACEBOOK NATIVE*/ ||
      ['1000', '1001', '1003' /*<-- APPLE NATIVE (100x)*/, 'auth/popup-closed-by-user'].includes(
        error.code
      ) ||
      error.message === 'The popup has been closed by the user before finalizing the operation.'
    ) {
      return;
    }

    throw error;
  }

  abstract nativeOAuth(config?: any): Promise<BoxxOAuthResponseProps>;
  abstract webOAuth(config?: any): Promise<BoxxOAuthResponseProps>;
}
